const commonFunc = (event) => {
  event.stopImmediatePropagation()
}

export default ($event, second) => {
  console.log('guardRapidClick')
  const target = $event.target
  target.classList.add('guardRapidClick')
  target.addEventListener('click',commonFunc,true)
  
  if(typeof second !== 'undefined'){
    setTimeout(()=>{
      target.classList.remove('guardRapidClick')
      target.removeEventListener('click',commonFunc,true)
    }, second)
  }
}